export default __webpack_public_path__ + "static/media/ilian_l.bbfe9f7c.jpg";